import { NOTIFICATION_TYPES, openNotification } from '../Components/Notifications/NotificationsUtils';
import { extractErrorPayload } from './extractErrorPayload';
import { parseImportExcelError } from './parseImportExcelError';

export const showImportError = async (e: any): Promise<void> => {
  const payload = await extractErrorPayload(e);
  const imp = parseImportExcelError(payload);

  const lines = [
    imp.detail,
    imp.sheet ? `Foaie: ${imp.sheet}` : undefined,
    imp.row != null ? `Rând: ${imp.row}` : undefined,
    imp.code ? `Cod: ${imp.code}` : undefined,
    imp.status ? `HTTP: ${imp.status}` : undefined,
    imp.url ? `URL: ${imp.url}` : undefined,
  ].filter(Boolean);

  openNotification(
    imp.title || 'Eroare la import',
    lines.length ? lines.join('\n') : 'A apărut o eroare la import.',
    NOTIFICATION_TYPES.ERROR
  );
};
